import * as CONST from '../ActionTypes';
import * as util from './util';

/**
 * ログイン
 */
export const login = (param) => (dispatch) => {
  dispatch(util.loading());
  return fetch(
    // eslint-disable-next-line no-undef
    `${process.env.REACT_APP_ENDPOINT}/api/v1/customers/signin_with_email`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(param),
      mode: 'cors',
    },
  )
    .then((response) => response.json())
    .then((payload) => {
      if (payload.access_token && payload.refresh_token) {
        util.setToken(payload.refresh_token);
        dispatch(util.actionType(CONST.LOGIN_SUCCESS, payload));
        localStorage.setItem('company', JSON.stringify(payload.company));
        dispatch(util.unLoading());
      } else {
        dispatch(util.actionType(CONST.LOGIN_FAILURE, payload));
        dispatch(util.unLoading());
      }
    })
    .catch((error) => {
      dispatch(util.actionType(CONST.LOGIN_FAILURE, error));
      dispatch(util.unLoading());
    });
};

/**
 * リフレッシュトークンでログイン
 */
export const refreshTokenLogin = (param) => (dispatch) => fetch(
  `${process.env.REACT_APP_ENDPOINT}/api/v1/customers/refresh_token`,
  {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify(param),
    mode: 'cors',
  },
)
  .then((response) => response.json())
  .then((payload) => {
    if (payload.access_token && payload.refresh_token) {
      util.setToken(payload.refresh_token);
      dispatch(util.actionType(CONST.REFRESH_TOKEN_SUCCESS, payload));
    } else {
      localStorage.removeItem('refresh_token');
      dispatch(util.actionType(CONST.REFRESH_TOKEN_FAILURE, payload));
    }
  })
  .catch((error) => {
    localStorage.removeItem('refresh_token');
    dispatch(util.actionType(CONST.REFRESH_TOKEN_FAILURE, error));
  });

/**
 * 新規登録
 */
export const signup = (param) => (dispatch) => {
  dispatch(util.loading());
  return fetch(`${process.env.REACT_APP_ENDPOINT}/api/v1/customers/signup`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify(param),
    mode: 'cors',
  })
    .then((response) => response.json())
    .then((payload) => {
      if (!payload.status) {
        dispatch(util.actionType(CONST.SIGN_UP_SUCCESS, null));
        dispatch(util.unLoading());
      } else if (payload.detail === 'email already exists') {
        dispatch(
          util.actionType(CONST.SIGN_UP_FAILURE, 'メールが存在しました'),
        );
        dispatch(util.unLoading());
      } else {
        dispatch(
          util.actionType(
            CONST.SIGN_UP_FAILURE,
            'カード情報をお確かめの上、もう一度お試しください',
          ),
        );
        dispatch(util.unLoading());
      }
    })
    .catch((error) => {
      dispatch(util.actionType(CONST.SIGN_UP_FAILURE, error));
      dispatch(util.unLoading());
    });
};

/**
 * ログアウト
 */
export const logout = () => (dispatch) => {
  dispatch(util.actionType(CONST.REFRESH_TOKEN_FAILURE, null));
  dispatch(util.actionType(CONST.GET_BUY_HISTORY_FAILURE, null));
  localStorage.removeItem('refresh_token');
};

export const sendMailResetPassword = (param) => (dispatch) => {
  dispatch(util.loading());
  return fetch(
    `${process.env.REACT_APP_ENDPOINT}/api/v1/customers/send_reset_password_mail`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(param),
      mode: 'cors',
    },
  )
    .then((payload) => {
      if (payload.status === 200) {
        dispatch(
          util.actionType(CONST.SEND_MAIL_RESET_PASSWORD_SUCCESS, payload),
        );
        dispatch(util.unLoading());
      } else if (payload.status === 404) {
        dispatch(
          util.actionType(
            CONST.SEND_MAIL_RESET_PASSWORD_FAILURE,
            'Eメールに一致するユーザーが見つかりませんでした。',
          ),
        );
        dispatch(util.unLoading());
      } else {
        dispatch(
          util.actionType(
            CONST.SEND_MAIL_RESET_PASSWORD_FAILURE,
            '時間をおいてもう一度お試しください。',
          ),
        );
        dispatch(util.unLoading());
      }
    })
    .catch((error) => {
      dispatch(util.actionType(CONST.SEND_MAIL_RESET_PASSWORD_FAILURE, error));
      dispatch(util.unLoading());
    });
};

/**
 * PW更新
 */
export const updatePassword = (accessToken, param) => (dispatch) => {
  dispatch(util.loading());
  return fetch(`${process.env.REACT_APP_ENDPOINT}/api/v1/customers/update_password`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify(param),
    mode: 'cors',
  })
    .then((payload) => {
      if (payload.status === 200) {
        dispatch(util.actionType(CONST.UPDATE_PASSWORD_SUCCESS, null));
        dispatch(util.unLoading());
      } else {
        dispatch(
          util.actionType(
            CONST.UPDATE_PASSWORD_FAILURE,
          ),
        );
        dispatch(util.unLoading());
      }
    })
    .catch((error) => {
      dispatch(util.actionType(CONST.UPDATE_PASSWORD_FAILURE, error));
      dispatch(util.unLoading());
    });
};
export const clearResultFlg = () => ({
  type: CONST.CLEAR_RESULT_FLG,
});
